import Color from "color";

export default {
  zwart: new Color("#000000"),
  wit: new Color("#ffffff"),
  blauw: new Color("#1E64C8"),
  rood: new Color("#DC4E28"),
  groen: new Color("#71A860"),
  geel: new Color("#FFD200"),
  paars: new Color("#825491"),
  oranje: new Color("#FB7E3A"),
};
